const config = {
  appName: "The CuttingBar",
};

export default config;